import {DataTableColumn} from "mantine-datatable";
import {I18n} from "@aws-amplify/core";
import {Badge, Text} from "@mantine/core";
import {ProviderMapping} from "../types.ts";

const getSyncStatusColor = (status: string) => {
    switch (status) {
        case 'Synced': return 'green';
        case 'Pending': return 'yellow';
        case 'Failed': return 'red';
        case 'Conflict': return 'orange';
        default: return 'gray';
    }
};

export const useTableColumns = (
    {onRecordClick}: { onRecordClick: (record: ProviderMapping) => void },
) => {

    const columns: DataTableColumn<ProviderMapping>[] = [
        {
            accessor: 'entityType',
            title: I18n.get('Entity Type'),
            render: (record: ProviderMapping) => (
                <Badge variant="light">{record.entityType}</Badge>
            ),
        },
        {
            accessor: 'billingProvider.name',
            title: I18n.get('Billing Provider'),
            render: (record: ProviderMapping) => (
                <Text
                    c="blue"
                    style={{cursor: 'pointer'}}
                    onClick={() => onRecordClick(record)}
                >
                    {record.billingProvider?.name || record.billingProviderId}
                </Text>
            ),
        },
        {
            accessor: 'providerEntityId',
            title: I18n.get('Provider Entity ID'),
            render: (record: ProviderMapping) => (
                <Text c="dimmed" size="sm">{record.providerEntityId}</Text>
            ),
        },
        {
            accessor: 'syncStatus',
            title: I18n.get('Sync Status'),
            render: (record: ProviderMapping) => (
                <Badge color={getSyncStatusColor(record.syncStatus)} variant="light">
                    {record.syncStatus}
                </Badge>
            ),
        },
        {
            accessor: 'lastSyncAt',
            title: I18n.get('Last Sync'),
            render: (record: ProviderMapping) => (
                <Text size="sm" c="dimmed">
                    {record.lastSyncAt ? new Date(record.lastSyncAt).toLocaleString() : 'Never'}
                </Text>
            ),
        },
    ];

    return {
        columns,
    };
};
